import { render, staticRenderFns } from "./page-login.vue?vue&type=template&id=1c948b44&"
import script from "./page-login.vue?vue&type=script&lang=js&"
export * from "./page-login.vue?vue&type=script&lang=js&"
import style0 from "./page-login.vue?vue&type=style&index=0&id=1c948b44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports